import Navigation from '../components/Navigation';

export default function PageError() {
  return (
    <div>
      <Navigation />
      <h1 className='page-404-title'>
        Error 404
        <br />
        La page que vous chercher n'existe pas{' '}
      </h1>
      <div className='page-404-img'>
        <img
          src='./img/thrulkhor-02.webp'
          alt='article 1'
          className='banner__image--top-01 banner--tiny page-404-img '
        />
      </div>{' '}
    </div>
  );
}
